import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { NgxScannerQrcodeService, ScannerQRCodeConfig, ScannerQRCodeResult, ScannerQRCodeSelectedFiles } from 'ngx-scanner-qrcode';
import { LocalService } from '../../../service/local.service';

@Component({
  selector: 'app-qr-scanner',
  templateUrl: './qr-scanner.component.html',
  styleUrls: ['./qr-scanner.component.scss']
})
export class QrScannerComponent {
  public qrCodeResult: ScannerQRCodeSelectedFiles[] = [];
  @Output() onQrScanned = new EventEmitter();
  htmlId: string = ''; elementIds: any;
  mediaDevice: MediaDeviceInfo[];
  currentDeviceId: string = '';
  @Input() isStart: boolean = false;
  @Output() isStartChange = new EventEmitter();

  public config: ScannerQRCodeConfig;

  constructor(public localService: LocalService, private qrcode: NgxScannerQrcodeService) {
    this.htmlId = this.localService.getRandomString(5);
    this.elementIds = {
      scanner_area: 'scanner_area_' + this.htmlId,
      scanner_camera: 'scanner_camera_' + this.htmlId,
      scanner_camera_cancel: 'scanner_camera_cancel_' + this.htmlId,
    };

    let lastCamera = this.localService.getLastCamera().value;
    if (lastCamera) {
      this.config = {
        // fps: 1000,
        vibrate: 400,
        //isAuto: false,
        // isBeep: true,
        // decode: 'macintosh',
        //deviceActive: 1,
        constraints: {
          audio: false,
          video: {
            width: window.innerWidth,
            deviceId: lastCamera
          } as MediaTrackConstraints
        }
      } as ScannerQRCodeConfig;
    } else {
      this.config = {
        // fps: 1000,
        vibrate: 400,
        //isAuto: false,
        // isBeep: true,
        // decode: 'macintosh',
        //deviceActive: 1,
        constraints: {
          audio: false,
          video: {
            width: window.innerWidth
          } as MediaTrackConstraints
        }
      } as ScannerQRCodeConfig;
    }
  }

  ngOnChanges(): void {
    if (this.isStart) {
      setTimeout(() => {
        this.onClickCamera();
      }, 100);
    }
  }

  onGetUserMediaDevices() {
    if (!this.mediaDevice) {
      navigator.mediaDevices.getUserMedia({ video: true })
        .then(() => {
          this.onGetCameraDevices();
        });
    }
  }

  onGetCameraDevices() {
    navigator.mediaDevices.enumerateDevices()
      .then((devices) => {
        this.mediaDevice = devices.filter(device => device.kind === 'videoinput');
        this.onSetDeviceId();
      });
  }

  onSetDeviceId(deviceId?: string) {
    if (!this.mediaDevice) {
      this.onGetUserMediaDevices();
    } else {
      let item = this.config.constraints.video as MediaTrackConstraints;
      let existVideoDevice = item.deviceId;
      if (deviceId) {
        this.currentDeviceId = deviceId;
      } else if (this.mediaDevice && this.mediaDevice.length > 0) {
        let lastCameraValue = this.localService.getLastCamera().value;
        let item = this.mediaDevice.find(x => x.deviceId == lastCameraValue);
        this.currentDeviceId = item ? lastCameraValue : this.mediaDevice[0].deviceId;
      }
      if (this.currentDeviceId) {
        if (existVideoDevice != this.currentDeviceId)
          this.onClickCamera();
        this.config.constraints.video = {
          width: window.innerWidth,
          deviceId: this.currentDeviceId
        } as MediaTrackConstraints;
        if (existVideoDevice != this.currentDeviceId)
          this.onClickCamera();
        this.localService.setLastCamera(this.currentDeviceId);
      }
    }
  }

  onAction(index: number) {
    switch (index) {
      case 1: {
        this.onClickCamera();
        if (this.mediaDevice && this.mediaDevice.length > 1) {
          const deviceIds = this.mediaDevice.map(x => x.deviceId);
          const currentIndex = deviceIds.indexOf(this.currentDeviceId);
          if (currentIndex > -1) {
            if (deviceIds.length == (currentIndex + 1)) {
              this.onSetDeviceId(deviceIds[0]);
            } else {
              this.onSetDeviceId(deviceIds[currentIndex + 1]);
            }
          }
        }
        this.onClickCamera();
      } break;
    }
  }

  onSetPosition() {
    // setTimeout(() => {
    //   let elementCamera = document.getElementById(this.elementIds.scanner_camera);
    //   let elementCameraArea = document.getElementById(this.elementIds.scanner_area);
    //   if (elementCamera && elementCameraArea) {
    //     elementCameraArea.style.left = this.isStartFromLeft ? '20px' : ((elementCamera.offsetLeft - 265) + 'px');
    //   }
    // }, 10);
  }

  onScanned(e: ScannerQRCodeResult[]) {
    this.qrCodeResult = [];
    if (e && e.length > 0) {
      let value = e[0].value;
      if (value && value != '') {
        this.onClickCamera();
        this.onQrScanned.emit(value);
      }
    }
  }

  onClickCamera() {
    this.onGetUserMediaDevices();
    let elementCamera = document.getElementById(this.elementIds.scanner_camera);
    if (elementCamera) {
      elementCamera.click();
    }
  }

  public handle(action: any, fn: string): void {
    action[fn]().subscribe(console.log, alert);
  }

  public onSelects(files: any) {
    this.qrcode.loadFiles(files).subscribe((res: ScannerQRCodeSelectedFiles[]) => {
      this.qrCodeResult = res;
    });
  }

  onCancel() {
    this.isStart = false;
    this.isStartChange.emit(this.isStart);
  }

  toggleScanner(scanner: any) {
    if (scanner.isStart) {
      scanner.stop();
      this.onCancel();
    } else {
      scanner.start();
      this.onGetUserMediaDevices();
    }
  }

}
